import React from "react";
import cn from "classnames";

import styles from "./preloader.module.css";

export const Preloader = ({ className }) => {
  return <div role="status" aria-label="loading" className={cn(className, styles.preloader)} />;
};

export const OverlayPreloader = ({ spinnerClassName, overlayClassName }) => {
  return (
    <React.Fragment>
      <div className={cn("sectionOverlay", overlayClassName)} />
      <div role="status" aria-label="loading" className={cn(spinnerClassName, styles.preloader)} />
    </React.Fragment>
  );
};

export const OverlayPreloaderAbsolute = ({ spinnerClassName, overlayClassName }) => {
  return (
    <React.Fragment>
      <div className={cn(styles.sectionOverlayAbsolute, overlayClassName)} />
      <div role="status" aria-label="loading" className={cn(spinnerClassName, styles.preloaderAbsolute)} />
    </React.Fragment>
  );
};
